
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { Truck } from './truck.model';

@Injectable({
  providedIn: 'root'
})
export class TruckOverviewService {

  constructor(private appServerAPI: AppServerAPI) { }

  public getTrucks(): Observable<Truck[]> {
    const url = `/client/control/transportoverview/trucks`;
    return this.appServerAPI.execute<Truck[]>(url, {});
  }
}
